import { ZyYoutubeVideoIcon } from '@/components/tiptap-editor/tiptap-icons/zyyoutubevideo-icon';
import { isSelectionTopNode } from '@/lib/zy-tiptap-utils';
import { forwardRef } from 'react';
import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

export const ZyYoutubeVideoButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => (
    <GenericExtensionButton
        extensionName="zyYoutubeVideo"
        extensionType="node"
        icon={ZyYoutubeVideoIcon}
        isDisabled={editor => !isSelectionTopNode(editor)}
        label="Insert zyYoutubeVideo"
        command={editor => editor.commands.insertZyYoutubeVideo()}
        ref={ref}
        {...props}
    />
));

ZyYoutubeVideoButton.displayName = 'ZyYoutubeVideoButton';

export default ZyYoutubeVideoButton;
